import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { setProfile } from "../redux/actions/themeActions";
import AuthService from "./../libs/services/auth";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";


function AuthGuard({ theme, dispatch, component }) {
    const [status, setStatus] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        checkToken();
    }, []);
    
    useEffect(() => {
        console.log("Current ", getAuth().currentUser);
    }, [component]);

    const checkToken = async () => {
        if (!theme.profile || !localStorage.getItem("token")) {
            try {
                let user = await AuthService.getProfile(true);
                if (!user) {
                    navigate(`/login`);
                } 
                setStatus(true);
                dispatch(setProfile(user))
                return;
            } catch (error) {
                navigate(`/login`);
            }
        } else {
            setStatus(true);
        }
    }

    return status ? <React.Fragment>{component}</React.Fragment> : <React.Fragment></React.Fragment>;

}

// class AuthGuardClass extends React.Component {

//     state = {
//         status: false
//     }

//     async componentDidMount() {
//         if (!this.props.theme.profile || !localStorage.getItem("token")) {
//             try {
//                 let user = await AuthService.getProfile(true);
//                 let status = this.state.status;
//                 if (!user) {
//                     this.props.history.push(`/login`);
//                 } else {
//                     status = true;
//                 }
//                 this.setState({ status: true }, () => {
//                     this.props.dispatch(setProfile(user))
//                 });
//                 return;
//             } catch (error) {
//                 this.props.navigate(`/login`);
//             }
//         } else {
//             this.setState({ status: true });
//         }
//     }

//     render() {
//         return this.state.status ? <React.Fragment>{this.props.component}</React.Fragment> : <React.Fragment></React.Fragment>;
//     }
// }

// function AuthGuard(props) {
//     const navigate = useNavigate();
//     return <AuthGuardClass {...props} navigate={navigate} />
// }

export default connect(store => ({ theme: store.themeReducer }))(AuthGuard)